module.exports = __webpack_public_path__ + "static/energy_private_11-f0c8e84538b20dbeb54ddaf997a5bb43.jpg";